module.exports = __webpack_public_path__ + "account/assets/ref-copy-icon-white.2aadbb0e.svg";